<template>
    <div class="loginpage">
        <div class="login-box" v-bind:class="{ changewidth: isActive }">
            <img style="margin-top: 50px;" src="../assets/antgine_LOGO.png">
            <p class="login-title" style="font-size: 30px;">蚁巢云平台</p>
            <div class="login-box-body">
                <el-form :model="loginForm" :rules="rules2" ref="loginForm" >
                    <el-form-item prop="name" style="margin: 0 auto;width: 300px;background-color: #f7f7f7;border-radius: 5px;">
                        <el-input type="text" size="large" v-model="loginForm.name" auto-complete="off" placeholder="请输入您的账号">
                        </el-input>
                    </el-form-item >
                    <el-form-item prop="password"  style="margin: 0 auto;width: 300px;background-color: #f7f7f7;border-radius: 5px;">
                        <el-input type="password" size="large" v-model="loginForm.password" auto-complete="off" placeholder="请输入您的密码"></el-input>
                    </el-form-item>
                    <!--<el-form-item prop="checkPass" class="form-group has-feedback">-->
                        <!--<el-input class="checklog" type="text" size="large" v-model="loginForm.checkPass" auto-complete="off" placeholder="请输入验证码！"></el-input>-->
                        <!--<el-button type="info" class="right showBtn" @click="createCode()"  >{{checkPwd}}</el-button>-->
                    <!--</el-form-item>-->
                    <el-form-item>
                        <el-button :plain="true" @click="submitForm('loginForm')" :loading="loginload" style="border-radius: 5px;background-color:#fb3846;color: #fff;width: 300px;margin-top:30px; ">确定</el-button>
                        <!--<el-button @click="resetForm('loginForm')">重置</el-button>-->
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    //*********2-20 修改
   /* import secret from '../assets/js/jsencrypt.min'*/

    //**********end
    import secret from '../assets/js/jsencrypt.min'
    var encrypt = new secret.JSEncrypt();
    export default {
        created(){
            this.createCode();
        },
        mounted () {
            const that = this;
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.screenWidth = window.screenWidth
                })()
            }
        },
        data() {
            var validateName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入用户名！'));
                } else {
                    if (this.loginForm.password !== '') {
                        this.$refs.loginForm.validateField('password');
                    }
                    callback();
                }
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码！'));
                }else {
                    callback();
                }
            };
//            var validateCheckpass = (rule, value, callback) => {
//                if (value === '') {
//                    callback(new Error('请输入验证码！'));
//                }else if(value.toUpperCase()!==this.checkPwd.toUpperCase()){
//                    callback(new Error('验证码错误，可点击重新获取'));
//                    this.loginload=false;
//                }
//                else {
//                    callback();
//                }
//            };

            return {
                screenWidth: document.body.clientWidth,
                isActive:true,
                loginForm: {
                    name: '',
                    password: ''
//                    checkPass: ''
                },
                loginload:false,
                checkPwd:'12345',
                rules2: {
                    name: [
                        { validator: validateName, trigger: 'blur' }
                    ],
                    password: [
                        { validator: validatePass, trigger: 'blur' },
                    ]
//                    checkPass: [
//                        { validator: validateCheckpass, trigger: 'blur' }
//                    ]
                }
            };
        },
        methods: {
            submitForm(formName) {

                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        var _this=this;
                       // var encrypt =new encrypt.JSEncrypt();


                        //加密文本（已经用base64加密过的）
                        //*********2-20 修改
                        this.loginload=true;
                        var pass ="";
                        encrypt.setPublicKey(this.publickey);
                        pass= encrypt.encrypt(this.loginForm.password);
                        this.$http.post(this.requetHost+'/sys/user/login', {username:this.loginForm.name,password:pass})
                            .then(response => {
                                    if (response.status === 200) {
                                        //var data = response.body;
                                        if ( response.body.status == "200") {

                                            this.getfindPermissions();
                                            //缓存用户Js
                                            this.savecookie("user_token", response.body.user_token, 30);
                                            this.savecookie("userId", response.body.userId, 30);
                                            this.savecookie("access_id",  response.body.access_id, 30);
                                            this.savecookie("username_client",  response.body.username, 30);
                                            this.savecookie("storeId",  response.body.storeId, 30);
                                            this.savecookie("wcLogin", 0, 30)
                                            this.savecookie("child", null)
                                            this.savecookie("button", null);


                                            //数据请求
                                            this.$http.get(this.requetHost + '/sys/user/findPermissions', {
                                                params: {
                                                    "userName": this.getcookie('username'),
                                                    "pid": '02'
                                                }
                                            }).then(response => {
                                                if (response.status === 200) {
                                                    this.data2 = response.body.tree.slice().sort();
                                                    console.log(this.data2[0].children );
                                                    if(this.data2[0].children != undefined){
                                                        this.$router.push(this.data2[0].children[0].url);
                                                        //this.  =response.body.tree[0].children;
                                                        //缓存Js
                                                        this.savecookie("child", JSON.stringify(this.data2[0]));
                                                    }else {
                                                        alert("没有配置菜单的权限");
                                                    }


                                                    //this.child = this.data2.children;
                                                }

                                            },function (response) {
                                                this.$message({
                                                    showClose: true,
                                                    message: '网络异常',
                                                    type: 'error'

                                                });
                                            })

                                                //this.$router.push('/main');

                                           /* if(response.body.isAdmin == "1"){
                                                this.$router.push('/content/04/userManager');
                                                this.savecookie("menu_url","/content/04/userManager",24*60*60);
                                            }else{
                                                this.$router.push('/content/04/orgManager');
                                                this.savecookie("menu_url","/content/04/orgManager",24*60*60);
                                            }*/

                                        }else{
                                            this.$message({
                                                showClose: true,
                                                message: ''+response.body.msg,
                                                type: 'error'

                                            });
                                        }
                                    }
                                },function(response){
                                    this.$message({
                                        showClose: true,
                                        message: '网络异常',
                                        type: 'error'

                                    });
                                }
                            )
                        //*********2-20 修改
//                        this.$store.dispatch('login', {username:this.loginForm.name,password:this.loginForm.password}).then(() => {
//                                // new Base().savecookie("username",data.username,30);
//                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
                this.loginload=false;
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            getfindPermissions(){
            },
            createCode(){
                var code="";
                var codeLength = 4;//验证码的长度
                var selectChar = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
                    'a','b','c','d','e','f','g','h','i','j','k','m','n','o','p','q','r','s','t','u','v','w','x','y','z',
                    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z');//所有候选组成验证码的字符，当然也可以用中文的
                for (var i = 0; i < codeLength; i++) {
                    var charIndex = Math.floor(Math.random() * 52);
                    code+= selectChar[charIndex];
                }
                this.checkPwd=code;
            }
        },
        watch: {
            screenWidth (val) {
                this.screenWidth = val
                if (this.screenWidth > 769) {
                    this.isActive = true;
                } else {
                    this.isActive = false;
                }
            }
        },
        route: {
            activate (transition) {
            }
        }
        /*优化 因为 频繁 触发 resize 函数，导致页面很卡的 问题*/
        /* watch: {
         screenWidth (val) {
         if (!this.timer) {
         this.screenWidth = val
         this.timer = true
         let that = this
         setTimeout(function () {
         // that.screenWidth = that.$store.state.canvasWidth
         console.log(that.screenWidth)
         if(that.screenWidth>769) {
         console.log("缩小啦")
         }
         that.init();
         that.timer = false
         }, 400)
         }
         }
         }*/
    }
</script>
<style>
    /*@import url('../assets/css/bootstrap.min.css');*/

    .loginpage{
        position: absolute;
        width: 100%;
        height: 100%;
        font-family: Helvetica, sans-serif;
        text-align: center;
        background-image:url("../assets/loginin_bg.jpg");
        background-repeat: no-repeat;
        background-size:cover;
    }
    .login-box{
        /*opacity:0.9;*/
        background-color: #fff;
        /*filter:alpha(opacity=90);*/
        /*color:black;*/
        width: 412px;
        height: 442px;
        /*margin: 6% auto;*/
        margin: 202px 0 0 55%;
        /*padding-top: 50px;*/
        border-radius:5px;
        border:6px solid rgb(255,255,255,0.3);
        /*border-color: #fff alpha(opacity=90);*/
    }
    .changewidth{
        width: 450px;
    }
    .login-box-body{
        margin-top: 60px;
        background: #fff;
        padding: 0 20px;
    }
    .login-title{
        /*line-height: 80px;*/
        font-size: 30px;
        margin-top: 16px;
        /*font-weight: 200;*/
        color: #757575;
        /*text-shadow: 0 1px 4px rgba(0,0,0,.2);*/
        /*background-image:url("../assets/images/login/flowle.png");*/
        /*background-repeat: no-repeat;*/
        /*background-size:100%,100%;*/
    }
    .demo-ruleForm{
        position: relative;
        /* text-align: center;*/
        margin: 15px auto 0 auto;
    }
    /*input{*/
    /*margin-top: 10px;*/
    /*}*/
    .right{
        width: 35%;
        padding-top: 10px;
        line-height: 20px;
        float: right;
        font-size: 20px;
    }
    .checklog{
        width: 60%;
        float: left;
    }
    .submitlog{
        text-align: center;
    }
    .prepend-input-span{
        width:10px;
        background-color:#29b0b8;
    }
    @import "../assets/css/button.css";
</style>



// WEBPACK FOOTER //
// Login.vue?390093f0